import { render, staticRenderFns } from "./TablesView.vue?vue&type=template&id=2d02d91e&"
import script from "./TablesView.vue?vue&type=script&lang=ts&"
export * from "./TablesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports